<template>

<fragment>

    <div class="grid">

        <app-view-grid-item 
            :fields="fields" 
            :filter="filter" 
            :item="item" 
            :can="can"
            :key="item.id" 
            v-for="item in data" 
        />

    </div>

    <slot></slot>

</fragment>

</template>

<script>

export default {

	props: ['data', 'fields', 'filter', 'view', 'can'],

    computed: {

    }

}

</script>

<style scoped>

.grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    grid-gap: 20px;
}

.is-mobile .grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    grid-gap: 10px;
}

</style>